import {
    faAlignJustify,
    faHome,
    faSearch,
    faShoePrints,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ColumnDescription } from "react-bootstrap-table-next";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import { MapLike } from "typescript";
import SpinnerComponent from "../../../../../Components/Loding/Spinner";
import Table from "../../../../../Components/Table";
import HTMLRemover from "../../../../../Components/Utils/HTMLRemover";
import { ListarAtendimentosAssisTecController } from "../../../../../Controllers/AssistenciaTecnica/GestaoDeAtendimento/GestaoDeAtendimentoController";
import { ListarAtendimentosClienteController } from "../../../../../Controllers/AtendimentoCliente/GestaoDeAtendimento/GestaoDeAtendimentoControllers";
import { ListarAtendimentosController } from "../../../../../Controllers/Cobranca/GestaoAtendimento/GestaoAtendimentoController";
import { IAtendimentoCliente } from "../../../../../Interfaces/AtendimentoCliente/GestaoDeAtendimento/GestaoDeAtendimentoInterfaces";
import { IAtendimentoGenerico } from "../../../../../Interfaces/Geral/Atendimento/AtendimentoInterfaces";
import { ACESSOS } from "../../../../../Routes/Acessos";

interface ISelecionarAtendimentoProps {
    ID_MODULO: number;
    onIdCasoChange: (idCaso: number) => void;
}
interface IBuscaAtendimentosFormData {
    DS_CONTA: string;
    ID_CASO: number;
}
interface IListarAtendimentoRequest {
    DS_CONTA: string;
    ID_CASO?: number;
    NR_PAGINA: number;
}

const LINK_CASO: MapLike<{ Link: (IDCaso: number) => string } | undefined> = {
    [ACESSOS.ATENDIMENTO.ID_MODULO]: {
        Link: ACESSOS.ATENDIMENTO.TELAS.ATENDIMENTO.DS_LINK,
    },
    [ACESSOS.COBRANCA.ID_MODULO]: {
        Link: ACESSOS.COBRANCA.TELAS.ATENDIMENTO.DS_LINK,
    },
};

export default function SelecionarAtendimento(
    props: ISelecionarAtendimentoProps
) {
    const [listarRequest, setListarRequest] =
        useState<IListarAtendimentoRequest>();
    const [lstAtendimentos, setLstAtendimentos] =
        useState<Array<IAtendimentoGenerico>>();
    const [loading, setLoading] = useState(false);
    const [paginas, setPaginas] = useState(1);

    const { register, handleSubmit } = useForm<IBuscaAtendimentosFormData>();

    useEffect(() => {
        if (listarRequest) {
            if (props.ID_MODULO === ACESSOS.COBRANCA.ID_MODULO) {
                setLoading(true);
                const todaysDate = new Date();
                //instancia um objeto date de 3 meses antes da data de hoje
                const pastDate = new Date(
                    new Date().setMonth(todaysDate.getMonth() - 3)
                );
                ListarAtendimentosController(
                    {
                        ID_CONTA: 0,
                        DS_NOME_CONTA: listarRequest.DS_CONTA,
                        ID_CASO: listarRequest.ID_CASO,
                        NR_PAGINA: listarRequest.NR_PAGINA,
                        DT_PERIODO_INICIO: pastDate.toISOString().split("T")[0],
                        DT_PERIODO_FIM: todaysDate.toISOString().split("T")[0],
                    },
                    "GERAL"
                )
                    .then((res) => {
                        setPaginas(res.NR_TOTAL_PAGINAS);
                        setLstAtendimentos(res.LISTA_ATENDIMENTOS);
                    })
                    .finally(() => setLoading(false));
            } else if (props.ID_MODULO === ACESSOS.ATENDIMENTO.ID_MODULO) {
                setLoading(true);
                ListarAtendimentosClienteController(
                    {
                        ID_CONTA: 0,
                        //DS_STATUS_CASO: 'Aberto',
                        ID_ACOMPANHAMENTO: 0,
                        DS_NOME_CONTA: listarRequest.DS_CONTA,
                        ID_CASO: listarRequest.ID_CASO,
                    },
                    listarRequest.NR_PAGINA,
                    "GERAL"
                )
                    .then((res) => {
                        setPaginas(res.PAGINAS);
                        setLstAtendimentos(res.ATENDIMENTOS);
                    })
                    .finally(() => setLoading(false));
            } else if (props.ID_MODULO === ACESSOS.ASSISTENCIA.ID_MODULO) {
                setLoading(true);
                ListarAtendimentosAssisTecController(
                    {
                        ID_CONTA: 0,
                        DS_CONTA: listarRequest.DS_CONTA,
                        ID_CASO: listarRequest.ID_CASO,
                    },
                    listarRequest.NR_PAGINA,
                    "GERAL"
                )
                    .then((res) => {
                        setLstAtendimentos(res.ATENDIMENTOS);
                    })
                    .finally(() => setLoading(false));
            }
        }
    }, [listarRequest, props.ID_MODULO]);

    function handleBuscaAtendimentosFormSubmit(
        formData: IBuscaAtendimentosFormData
    ) {
        setListarRequest({
            DS_CONTA: formData.DS_CONTA,
            ID_CASO: formData.ID_CASO || 0,
            NR_PAGINA: 1,
        });
        props.onIdCasoChange(0);
    }

    //Tabela
    const atendimentoColumns: Array<ColumnDescription> = [
        {
            dataField: "ID_CASO",
            text: "Atendimentos",
            formatter: (_c, row) => <RowFormatter {...row} />,
        },
    ];
    function RowFormatter(row: IAtendimentoGenerico) {
        const link = LINK_CASO[props.ID_MODULO]?.Link;
        const DS_CATEGORIA = (row as IAtendimentoCliente).Atendimento
            ?.DS_CATEGORIA_ATENDIMENTO;
        const DS_ETAPA = (row as IAtendimentoCliente).Atendimento
            ?.DS_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO;

        return (
            <div className="card card-custom p-3">
                <div className="d-flex justify-content-between w-100">
                    <div>
                        <span className="text-dark-75">
                            {row.CONTA.DS_CONTATO !== row.CONTA.DS_NOME &&
                                row.CONTA.DS_CONTATO}
                        </span>
                        <span className="card-title font-weight-bolder font-size-h6 text-dark mb-1">
                            {row.CONTA.DS_NOME}
                        </span>
                    </div>
                    <OverlayTrigger
                        overlay={
                            <Tooltip id="tooltip-disabled">Atendimento</Tooltip>
                        }
                    >
                        {link ? (
                            <Link
                                to={link ? link(row.ID_CASO) : ""}
                                className={`label font-weight-bolder label-inline ml-2 label-light-primary bg-hover-light-info text-hover-info`}
                            >
                                {row.ID_CASO}
                            </Link>
                        ) : !!row.ID_CASO ? (
                            <span
                                className={`label font-weight-bolder label-inline ml-2 label-light-info`}
                            >
                                {row.ID_CASO}
                            </span>
                        ) : (
                            <></>
                        )}
                    </OverlayTrigger>
                </div>
                <div>
                    <HTMLRemover charLimit={50}>{row.DS_CASO}</HTMLRemover>
                </div>
                <div>
                    <span
                        className="label label-light-info label-inline mr-2 my-1"
                        style={{ height: "auto" }}
                    >
                        <FontAwesomeIcon icon={faHome} className="mr-1" />{" "}
                        {row.PRODUTO.DS_EMPREENDIMENTO} -{" "}
                        {row.PRODUTO.UNIDADE.DS_UNIDADE}
                    </span>
                    {DS_CATEGORIA && (
                        <span
                            className="label label-light-info label-inline mr-2 my-1"
                            style={{ height: "auto" }}
                        >
                            <FontAwesomeIcon
                                icon={faAlignJustify}
                                className="mr-1"
                            />{" "}
                            {DS_CATEGORIA}
                        </span>
                    )}
                    {DS_ETAPA && (
                        <span
                            className="label label-light-info label-inline mr-2 my-1"
                            style={{ height: "auto" }}
                        >
                            <FontAwesomeIcon
                                icon={faShoePrints}
                                className="mr-1"
                            />{" "}
                            {DS_ETAPA}
                        </span>
                    )}
                </div>
            </div>
        );
    }

    return (
        <div>
            <form
                className="row align-items-end"
                onSubmit={handleSubmit(handleBuscaAtendimentosFormSubmit)}
            >
                <div className="col-12 col-lg-8">
                    <div>
                        <label>Cliente</label>
                        <input
                            name="DS_CONTA"
                            className="form-control"
                            ref={register()}
                        />
                    </div>
                </div>
                <div className="col-9 col-lg-3">
                    <div>
                        <label>Protocolo</label>
                        <input
                            type="number"
                            name="ID_CASO"
                            ref={register({
                                valueAsNumber: true,
                            })}
                            className="form-control"
                        />
                    </div>
                </div>
                <div className="col-3 col-lg-1">
                    <button
                        type="submit"
                        className="w-100 btn btn-outline-primary"
                    >
                        {" "}
                        <FontAwesomeIcon icon={faSearch} />
                    </button>
                </div>
            </form>

            <div>
                {loading && !lstAtendimentos ? (
                    <SpinnerComponent />
                ) : lstAtendimentos ? (
                    <Table
                        columns={atendimentoColumns}
                        data={lstAtendimentos}
                        keyField="ID_CASO"
                        selectRow={{
                            mode: "radio",
                            onSelect: (
                                row: IAtendimentoGenerico,
                                isSelected
                            ) => {
                                props.onIdCasoChange(row.ID_CASO);
                            },
                            clickToSelect: true,
                        }}
                        onTableChange={(type, newState) => {
                            if (listarRequest) {
                                setListarRequest({
                                    ...listarRequest,
                                    NR_PAGINA: newState.page,
                                });
                            }
                        }}
                        remote={{ pagination: true }}
                        totalPages={paginas}
                        loading={loading}
                        noDataIndication={() => (
                            <div className="text-muted text-center">
                                Nenhum Atendimento encontrado
                            </div>
                        )}
                        noHover
                        noSearch
                        bordered={false}
                    />
                ) : (
                    <div className="text-muted text-center">
                        Faça a pesquisa acima para selecionar um atendimento
                    </div>
                )}
            </div>
        </div>
    );
}
